import { format } from 'date-fns';
import { CalendarIcon, ClockCounterClockwiseIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { formatRelativeTime } from '@/utils/date';

interface ReportInfoBarProps {
    createdAt: number;
    updatedAt: number;
}

export function ReportInfoBar({ createdAt, updatedAt }: ReportInfoBarProps) {
    const { t } = useTranslation(I18nNamespace.REPORTS);

    const createdAtLabel = format(new Date(createdAt * 1000), 'dd.MM.yyyy');
    const lastUpdatedLabel = formatRelativeTime(updatedAt);

    return (
        <aside className="w-full">
            <h2 className=" pb-6 text-base font-medium text-white-100">
                {t('detail.infoPanel.title')}
            </h2>
            <div className="divide-y divide-grey-500">
                <div className="flex flex-col gap-3 py-4">
                    <div className="text-sm font-normal text-grey-200">
                        {t('detail.infoPanel.lastUpdated')}
                    </div>
                    <div className="flex min-w-0 items-center gap-2">
                        <ClockCounterClockwiseIcon
                            className="size-4 shrink-0 text-grey-300"
                            aria-hidden
                        />
                        <span className="truncate text-sm font-normal text-white-100">
                            {lastUpdatedLabel}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col gap-3 py-4">
                    <div className="text-sm font-normal text-grey-200">
                        {t('detail.infoPanel.createdAt')}
                    </div>
                    <div className="flex min-w-0 items-center gap-2">
                        <CalendarIcon
                            className="size-4 shrink-0 text-grey-300"
                            aria-hidden
                        />
                        <span className="truncate text-sm font-normal text-white-100">
                            {createdAtLabel}
                        </span>
                    </div>
                </div>
            </div>
        </aside>
    );
}
